import state from './point.state'
import mutations from './point.mutations'
import actions from './point.actions'

export default {
  state,
  mutations,
  actions
}
